



















import Vue from "vue";
import { mapState } from "vuex";
import { IState } from "@/store";
import { Component } from "vue-property-decorator";
import { IBrand } from "@/models/brands";

@Component({
  computed: {
    ...mapState({
      brands: (state: IState) => state.auth.admin.brands,
      brandId: (state: IState) => state.auth.admin.brandId
    })
  }
})
export default class SelectBrandDropdown extends Vue {
  public readonly brands!: any;
  public readonly brandId!: IBrand["id"];

  public isProcessing = false;

  public selectBrand(brandId) {
    const brand = this.$_.find(this.brands, ["id", brandId]);
    if (brand && !this.isProcessing) {
      this.isProcessing = true;
      this.$emit("selected", brandId);
      this.$router
        .push({
          name: "adminBrand",
          params: {
            id: brandId,
            name: brand.name
          }
        })
        .catch(err => err)
        .finally(() => (this.isProcessing = false));
    }
  }
}
